import React from "react";
import { ContactInfo } from "./ContactInfo";
import { ContactForm } from "./ContactForm";

export const Contact = ({ serviceInterest, setServiceInterest }) => (
  <section id="contact" data-testid="contact-section" className="py-20 lg:py-24 bg-[#F4F6F3]">
    <div className="mx-auto max-w-[1180px] px-5 lg:px-8 grid lg:grid-cols-[0.85fr_1.15fr] gap-12 lg:gap-16">
      <ContactInfo />
      <ContactForm serviceInterest={serviceInterest} setServiceInterest={setServiceInterest} />
    </div>
  </section>
);
